import PropTypes from 'prop-types';
import TimelineErrorBoundary from 'crm-events-components/internal/error/TimelineErrorBoundary';
import { MeetingNotetakerAlertAndModal } from 'crm-meetings-components-lib/components/MeetingNotetakerAlertAndModal';
import TimelineErrorState from './ProfileTimelineErrorMessage';
import ErrorTypes from '../../constants/customErrorTypes';
// @ts-expect-error Could not find a declaration file
import { AnyCrmObjectTypePropType } from 'customer-data-objects-ui-components/propTypes/CrmObjectTypes';
import TimelineEventsPropType from '../../helpers/TimelineEventsPropType';
import TimelineVirtualized from './TimelineVirtualized';
// @ts-expect-error Could not find a declaration file
import { useStoreDependency } from 'general-store';
import { TimelineOverrideFavoriteEventDependency, TimelineOwnersFilterDependency, TimelineTeamsFilterDependency, TimelineTextFilterDependency, useSelectedTabOrEventFilters, useTimelineActionHandlerContext, TimelineStatusDependency, ShouldDisplayPinnedEngagementDependency } from 'crm-events-data';
import { useIsWindowVisible } from '../../../../hooks/useIsWindowVisible';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function TimelineWrapper(props) {
  const {
    objectType,
    subjectId,
    meetingsTabIsSelected
  } = props;
  const favoriteEventOverride = useStoreDependency(TimelineOverrideFavoriteEventDependency, {
    objectType
  });
  const searchText = useStoreDependency(TimelineTextFilterDependency, {
    objectType
  });
  const selectedTeams = useStoreDependency(TimelineTeamsFilterDependency, {
    objectType
  });
  const selectedOwners = useStoreDependency(TimelineOwnersFilterDependency, {
    objectType
  });
  const shouldDisplayPinnedEngagement = useStoreDependency(ShouldDisplayPinnedEngagementDependency, {
    subjectId,
    objectType
  });
  const {
    selectedEventFilters
  } = useSelectedTabOrEventFilters({
    objectType,
    subjectId
  });
  const timelineStatus = useStoreDependency(TimelineStatusDependency);
  const handleTimelineAction = useTimelineActionHandlerContext();
  const {
    isWindowVisible
  } = useIsWindowVisible();
  const passthruProps = Object.assign({}, props, {
    favoriteEventOverride,
    searchText,
    selectedTeams,
    selectedOwners,
    shouldDisablePolling: !isWindowVisible,
    shouldDisplayPinnedEngagement,
    timelineFavoriteEvents: selectedEventFilters,
    timelineStatus,
    handleTimelineAction
  });
  return /*#__PURE__*/_jsx(View, {
    minBlockSize: "500px",
    children: /*#__PURE__*/_jsx("div", {
      className: "onboarding-peek-timeline",
      children: /*#__PURE__*/_jsxs(TimelineErrorBoundary, {
        boundaryName: "TimelineWrapper_TimelineErrorState",
        ErrorComponent: TimelineErrorState,
        errorProps: {
          errorMessageType: ErrorTypes.TIMELINE,
          objectType
        },
        children: [meetingsTabIsSelected && /*#__PURE__*/_jsx(MeetingNotetakerAlertAndModal, {}), /*#__PURE__*/_jsx(TimelineVirtualized, Object.assign({}, passthruProps))]
      })
    })
  });
}
TimelineWrapper.propTypes = {
  activityTabIsSelected: PropTypes.bool,
  emailTabIsSelected: PropTypes.bool,
  events: TimelineEventsPropType,
  objectType: AnyCrmObjectTypePropType.isRequired,
  profileStartTime: PropTypes.number,
  selectedTab: PropTypes.string,
  subjectId: PropTypes.string.isRequired
};
export default TimelineWrapper;